// CVP 独立快速加购弹窗

// 拦截购物车在用户主动关闭后自动重开
(function() {
  function patchCartDrawer() {
    var cd = document.querySelector('cart-drawer-component');
    if (!cd || !cd.refs || !cd.refs.dialog) return false;
    var dialog = cd.refs.dialog;
    if (dialog._cvpPatched) return true;
    dialog._cvpPatched = true;

    var closeCount = 0;
    var cvpActive = false;

    dialog.addEventListener('close', function() {
      if (!cvpActive) return;
      closeCount++;
      if (closeCount === 2) {
        cvpActive = false;
        closeCount = 0;
        var style = document.createElement('style');
        style.id = 'cvp-unlock';
        style.textContent = 'body { overflow: auto !important; touch-action: auto !important; } html { overflow: auto !important; }';
        document.head.appendChild(style);
        setTimeout(function() {
          var el = document.getElementById('cvp-unlock');
          if (el) el.remove();
        }, 1000);
      }
    });

    var mo = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'open' && dialog.hasAttribute('open') && cvpActive && closeCount === 1) {
          setTimeout(function() { dialog.close(); }, 50);
        }
      });
    });
    mo.observe(dialog, { attributes: true, attributeFilter: ['open'] });

    document.addEventListener('dialog:close', function(e) {
      if (e.target && e.target.tagName === 'CART-DRAWER-COMPONENT') {
        cvpActive = true;
        closeCount = 1;
      }
    });

    return true;
  }

  if (!patchCartDrawer()) {
    var observer = new MutationObserver(function() {
      if (patchCartDrawer()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// 产品数据缓存
var _cvpProductCache = {};

function cvpPreloadAll() {
  document.querySelectorAll('[data-product-url]').forEach(function(el) {
    var url = el.dataset.productUrl;
    if (!url) return;
    var cacheKey = url.split('?')[0];
    if (_cvpProductCache[cacheKey]) return;

    var promise = fetch(window.Shopify.routes.root + cacheKey.replace(/^\//, '') + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        if (!product) throw new Error('No product data');
        var firstVariant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
        var imgSrc = (firstVariant && firstVariant.featured_image)
          ? firstVariant.featured_image.src
          : (product.images && product.images[0] ? product.images[0] : null);
        if (imgSrc) { var img = new Image(); img.src = imgSrc; }
        return product;
      })
      .catch(function() {
        delete _cvpProductCache[cacheKey];
        return null;
      });

    _cvpProductCache[cacheKey] = promise;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', cvpPreloadAll);
} else {
  cvpPreloadAll();
}

var _cvpPreloadObserver = new MutationObserver(function() {
  cvpPreloadAll();
});
_cvpPreloadObserver.observe(document.body, { childList: true, subtree: true });


window.cvpQAOpen = function(productUrl, preselectedModel) {
  var modal = document.getElementById('cvp-quick-add-modal');
  var overlay = document.getElementById('cvp-quick-add-overlay');
  var content = document.getElementById('cvp-qa-content');

  modal.classList.add('open');
  overlay.classList.add('open');

  var cacheKey = productUrl.split('?')[0];
  var cached = _cvpProductCache[cacheKey];

  if (!cached) {
    content.innerHTML = '<div style="text-align:center;padding:40px 0;color:#999;font-size:14px;">Loading...</div>';
    cached = fetch(window.Shopify.routes.root + cacheKey.replace(/^\//, '') + '.js')
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    _cvpProductCache[cacheKey] = cached;
  }

  cached
    .then(function(product) {
      if (!product) throw new Error('No product data');
      cvpQARender(product, preselectedModel);
    })
    .catch(function() {
      content.innerHTML = '<div style="text-align:center;padding:40px 0;color:#999;">Failed to load product.</div>';
    });
};

window.cvpQAClose = function() {
  var modal = document.getElementById('cvp-quick-add-modal');
  var overlay = document.getElementById('cvp-quick-add-overlay');
  modal.classList.remove('open');
  overlay.classList.remove('open');
};

function cvpQARender(product, preselectedModel) {
  var content = document.getElementById('cvp-qa-content');

  var modelIndex = -1, caseTypeIndex = -1, styleIndex = -1;
  product.options.forEach(function(opt, i) {
    var name = typeof opt === 'string' ? opt : opt.name;
    if (name === 'Model') modelIndex = i;
    if (name === 'Select Case Type') caseTypeIndex = i;
    if (name === 'Style') styleIndex = i;
  });

var availableVariants = product.variants.filter(function(v) {
  return v.available;
});

var firstAvailable = availableVariants[0] || product.variants[0];
var selectedModel = modelIndex >= 0 && firstAvailable
  ? firstAvailable.options[modelIndex]
  : null;

if (preselectedModel && modelIndex >= 0) {
  var modelExists = availableVariants.some(function(v) {
    return v.options[modelIndex] === preselectedModel;
  });

  if (modelExists) selectedModel = preselectedModel;
}

  var selectedCaseType = caseTypeIndex >= 0 ? firstAvailable.options[caseTypeIndex] : null;
  var selectedStyle = styleIndex >= 0 ? firstAvailable.options[styleIndex] : null;

  function getMatchedVariant() {
    return product.variants.find(function(v) {
      var m = modelIndex < 0 || v.options[modelIndex] === selectedModel;
      var c = caseTypeIndex < 0 || v.options[caseTypeIndex] === selectedCaseType;
      var s = styleIndex < 0 || v.options[styleIndex] === selectedStyle;
      return m && c && s;
    }) || product.variants[0];
  }

  function getActiveCurrency() {
    if (window.cvpShopMeta && window.cvpShopMeta.currency) return window.cvpShopMeta.currency;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) return window.Shopify.currency.active;
    return 'GBP';
  }

  function getActiveLocale() {
    if (window.cvpShopMeta && window.cvpShopMeta.locale) return window.cvpShopMeta.locale;
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    return document.documentElement.lang || 'en-GB';
  }

  function formatPrice(cents) {
    var currency = getActiveCurrency();
    var locale = getActiveLocale();
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(cents / 100);
    }
  }

function getUniqueValues(optionIndex, availableOnly) {
  var seen = {}, result = [];

  product.variants.forEach(function(v) {
    if (availableOnly && !v.available) return;

    var val = v.options[optionIndex];
    if (!seen[val]) {
      seen[val] = true;
      result.push(val);
    }
  });

  return result;
}

  function getVariantImageForCaseType(caseTypeValue) {
    var v = product.variants.find(function(v) { return v.options[caseTypeIndex] === caseTypeValue; });
    return v && v.featured_image ? v.featured_image.src : (product.images[0] || null);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function updatePriceAndButton() {
    var variant = getMatchedVariant();
    var priceEl = document.getElementById('cvp-qa-price');
    var atcBtn = document.getElementById('cvp-qa-atc');
    var imgEl = content.querySelector('.cvp-qa-image');
    var unavailableEl = content.querySelector('.cvp-qa-unavailable');

    if (priceEl) priceEl.textContent = formatPrice(variant.price);
    if (atcBtn) {
      atcBtn.dataset.variantId = variant.id;
      if (variant.available) {
        atcBtn.removeAttribute('disabled');
        atcBtn.textContent = 'Add to cart';
      } else {
        atcBtn.setAttribute('disabled', 'true');
        atcBtn.textContent = 'Sold out';
      }
    }
    if (imgEl && variant.featured_image) {
      var newSrc = variant.featured_image.src;
      if (imgEl.getAttribute('src') !== newSrc) imgEl.setAttribute('src', newSrc);
    }
    if (unavailableEl) unavailableEl.style.display = variant.available ? 'none' : 'block';
  }

  function render() {
    var variant = getMatchedVariant();
    var imgSrc = (variant.featured_image ? variant.featured_image.src : null) || product.images[0] || '';
    var price = formatPrice(variant.price);
    var available = variant.available;
    var html = '';

    if (imgSrc) {
      var preloadImg = new Image();
      preloadImg.src = imgSrc;
    }

    if (imgSrc) html += '<img class="cvp-qa-image" src="' + imgSrc + '" alt="' + escHtml(product.title) + '" loading="eager">';
    html += '<div class="cvp-qa-title">' + escHtml(product.title) + '</div>';
    html += '<div class="cvp-qa-price" id="cvp-qa-price">' + price + '</div>';

    if (modelIndex >= 0) {
      var models = getUniqueValues(modelIndex, true);
      html += '<div class="cvp-qa-section-label">Model</div>';
      html += '<select class="cvp-qa-select" id="cvp-qa-model">';
      models.forEach(function(m) {
        html += '<option value="' + escHtml(m) + '"' + (m === selectedModel ? ' selected' : '') + '>' + escHtml(m) + '</option>';
      });
      html += '</select>';
    }

    if (caseTypeIndex >= 0) {
      var caseTypes = getUniqueValues(caseTypeIndex);
      html += '<div class="cvp-qa-section-label">Select Case Type</div>';
      html += '<div class="cvp-qa-casetype-grid">';
      caseTypes.forEach(function(ct) {
        var ctImg = getVariantImageForCaseType(ct);
        var isSelected = ct === selectedCaseType;
        html += '<div class="cvp-qa-case-card' + (isSelected ? ' selected' : '') + '" data-casetype="' + escHtml(ct) + '">';
        if (ctImg) html += '<img src="' + ctImg + '" alt="' + escHtml(ct) + '" loading="lazy">';
        html += '<div class="cvp-qa-case-name">' + escHtml(ct) + '</div></div>';
      });
      html += '</div>';
    }

    if (styleIndex >= 0) {
      var styles = getUniqueValues(styleIndex);
      html += '<div class="cvp-qa-section-label">Style</div>';
      html += '<div class="cvp-qa-style-buttons">';
      styles.forEach(function(s) {
        var isSelected = s === selectedStyle;
        html += '<button class="cvp-qa-style-btn' + (isSelected ? ' selected' : '') + '" data-style="' + escHtml(s) + '" type="button">' + escHtml(s) + '</button>';
      });
      html += '</div>';
    }

    html += '<button class="cvp-qa-atc-btn" id="cvp-qa-atc" type="button" data-variant-id="' + variant.id + '"' + (!available ? ' disabled' : '') + '>';
    html += available ? 'Add to cart' : 'Sold out';
    html += '</button>';
    html += '<div class="cvp-qa-unavailable" style="display:' + (available ? 'none' : 'block') + '">This combination is unavailable</div>';

    content.innerHTML = html;
    bindEvents();
  }

  function bindEvents() {
    var modelSelect = document.getElementById('cvp-qa-model');
    if (modelSelect) {
      modelSelect.addEventListener('change', function() {
        selectedModel = modelSelect.value;
        updatePriceAndButton();
      });
    }

    content.querySelectorAll('.cvp-qa-case-card').forEach(function(card) {
      card.addEventListener('click', function() {
        selectedCaseType = card.dataset.casetype;
        content.querySelectorAll('.cvp-qa-case-card').forEach(function(c) { c.classList.remove('selected'); });
        card.classList.add('selected');
        updatePriceAndButton();
      });
    });

    content.querySelectorAll('.cvp-qa-style-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectedStyle = btn.dataset.style;
        content.querySelectorAll('.cvp-qa-style-btn').forEach(function(b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        updatePriceAndButton();
      });
    });

    // ── 加购逻辑：使用原生表单 click，让主题自己处理抽屉更新 ──
    var atcBtn = document.getElementById('cvp-qa-atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', function() {
        var variantId = parseInt(atcBtn.dataset.variantId);
        if (!variantId) return;
        var variant = getMatchedVariant();
        if (!variant || !variant.available) return;

        var nativeForm = document.querySelector('form[action="/cart/add"]');
        var nativeVariantInput = nativeForm ? nativeForm.querySelector('input[name="id"]') : null;
        var nativeAtcBtn = nativeForm ? nativeForm.querySelector('button[name="add"]') : null;
        var animEl = nativeForm ? nativeForm.querySelector('[data-add-to-cart-animation]') : null;

        if (nativeForm && nativeVariantInput && nativeAtcBtn) {
          // 原生路径：设置 variant ID 后直接 click，主题处理一切
          if (animEl) animEl.setAttribute('data-add-to-cart-animation', 'false');
          nativeVariantInput.value = variantId;
          cvpQAClose();
          nativeAtcBtn.click();
          setTimeout(function() {
            if (animEl) animEl.setAttribute('data-add-to-cart-animation', 'true');
          }, 1000);
        } else {
          // 降级路径：原生表单不存在时，直接 fetch 加购
          cvpQAClose();
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
          .then(function() {
            // 触发页面级购物车刷新
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(function(err) {
            console.error('CVP add to cart failed', err);
          });
        }
      });
    }
  }

  render();
}
